"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("./utils");
var FORMAT = {
    standard: utils_1.formatStandard,
    'date-only': utils_1.formatDateOnly,
    'date-only-with-timezone': utils_1.formatDateOnlyWithTimezone,
    'date-only-without-day': utils_1.formatDateOnlyWithoutDay,
};
var DateTime = function (_a) {
    var _b = _a.format, format = _b === void 0 ? 'date-only' : _b, children = _a.children;
    return react_1.default.createElement(react_1.default.Fragment, null, FORMAT[format](children));
};
DateTime.formatDateOnly = utils_1.formatDateOnly;
DateTime.formatDateOnlyWithoutDay = utils_1.formatDateOnlyWithoutDay;
DateTime.formatDateOnlyWithTimezone = utils_1.formatDateOnlyWithTimezone;
DateTime.formatStandard = utils_1.formatStandard;
exports.default = DateTime;
